import { createAction } from 'redux-actions'

export const setBrandData = createAction('BRAND_DETAILS/SET_BRAND_DATA')

export const setFiltersData = createAction('BRAND_DETAILS/SET_FILTERS_DATA')
